/* eslint-disable */
import httpClient from '@/utils/httpClient'
import {
  CarExtended,
  GetCarModelsResponse,
  GetCarsResponse,
  GetCarsWithoutDetailsResponse,
  UpdateCarSettingsResponse,
  TransferCarOtherRegionParkResponse,
  UploadCarPhotoResponse,
  DeleteCarPhotoRequest,
  UploadCarPhotoRequest
} from 'rikroot-types/parksmanagement/cars.pb'

export class ParkManagementRepository extends httpClient {
    resource = '/park_management/cars'

    public async getCars (params: string) {
      const response = await this.get(`${this.resource}`, { params })
      return response as GetCarsResponse
    }

    public async getCarModels (params: string) {
      const response = await this.get('/park_management/car_models', { params })
      return response as GetCarModelsResponse
    }

    public async getCarById (id: string) {
      const response = await this.get(`${this.resource}/${id}`)
      return response as CarExtended
    }

    public async getCarsShort (params: string) {
      const response = await this.get(`${this.resource}/list`, { params })
      return response?.cars as GetCarsWithoutDetailsResponse
    }

    public async saveTaxiCarsFromYandex (): Promise<void> {
      const response = await this.post(`${this.resource}/save_from_aggregator`)
      return response as void
    }

    public async updateCarSettings (data: UpdateCarSettingsResponse) {
      const response = await this.put(`${this.resource}/update_settings`, data)
      return response as UpdateCarSettingsResponse
    }

    public async useTransferRegionPark (data: TransferCarOtherRegionParkResponse) {
      const response = await this.post(`${this.resource}/transfer_region_park`, data)
      return response as TransferCarOtherRegionParkResponse
    }

    public async uploadPhotos (data: UploadCarPhotoRequest) {
      const response = await this.post(`${this.resource}/${data.carId}/photos`, data)
      return response as UploadCarPhotoResponse
    }

    public async deletePhotos (params: DeleteCarPhotoRequest): Promise<void> {
      const response = await this.delete(`${this.resource}/${params.carId}/photos`, { params })

      return response as void
    }
}
